import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f2d6dbc&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=2f2d6dbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2d6dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f2d6dbc')) {
      api.createRecord('2f2d6dbc', component.options)
    } else {
      api.reload('2f2d6dbc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2f2d6dbc&scoped=true", function () {
      api.rerender('2f2d6dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/webhook-logs/index.vue"
export default component.exports